import { uiText } from "@/lib/i18n/uiText";
import { useAuth } from "@/hooks/useAuth";

const COPY = {
  market: ["Market, pick, odds & confidence locked · sign in to view", "Market, pick, odds & confidence locked · open to reveal"],
  pick: ["Pick locked · sign in to view", "Pick locked · open to reveal"],
  view: ["sign in to view the pick", "reveal the pick below"],
} as const;

/** "Sign in" wording only for visitors; signed-in users see an unlock hint instead. */
export function LockedHint({ variant }: { variant: keyof typeof COPY }) {
  const { user } = useAuth();
  return <>{uiText(COPY[variant][user ? 1 : 0])}</>;
}
